import React, { useState, useEffect, useCallback } from "react";
import * as Mui from "@mui/material";
import { useSelector } from "react-redux";
import { showToast } from "services/utils/Status";
import moment from "moment";
import { Loader } from "components/Loader";
import sessionHandling from "services/utils/notificationUtils";
import { Typography, Box, Paper, Stack } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { useFetch } from "services/hooks/useFetch";
import { ArrowBackIos } from "@mui/icons-material";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import { checkViewerPermission } from "services/utils/HelperFunction";
import {
  themes,
  optionalAvathar,
  theme,
  defaultAllSelection,
} from "services/constants";
import { tooltipStyleProps } from "services/constants/Styles";
import { withDesignFont, designColors } from "services/constants/designTokens";
import { CustomFilter } from "components/CustomComponents/CustomFilter";
import { FilterProvider } from "pages/FilterContext";
import { ApproveTable } from "pages/TeamZone/Approve/approveUi";
import { TableEmptyState } from "components/CustomComponents/EmptyState";
import { lateReportHeader } from "../TeamZoneHeaders";
import { tableRowSx } from "services/constants";
import { BoxStyle, BackArrowStyle } from "services/constants";
import { FilterSection } from "pages/FilterContext/FilterRow";
import { IconButton } from "@material-ui/core";
import {
  ApprovalDateRangeFilter,
  filterBarPickerSx,
} from "components/CustomComponents/ApprovalDateRangeFilter";
import { getThisMonthRange } from "components/CustomComponents/dateRangeDefaults";

export const LateCountReport = ({ setShowReport }) => {
  const {
    domain,
    token,
    userDetails,
    topbarCompanyId,
    userScreenAccess,
    topbarCompanyName,
  } = useSelector((state) => state.tokenReducer);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  // Dates are kept as DD/MM/YYYY strings (the fetch below converts them).
  // Default is This Month; today is excluded (showToday is false).
  const [initialDateRange] = useState(() =>
    getThisMonthRange({ endAt: "yesterday" }),
  );
  const [startDate, setStartDate] = useState(
    moment(initialDateRange.startDate).format("DD/MM/YYYY"),
  );
  const [endDate, setEndDate] = useState(
    moment(initialDateRange.endDate).format("DD/MM/YYYY"),
  );
  const [labelName, setLabelName] = useState(initialDateRange.label);
  const { result: departmentData } = useFetch(
    `${domain}get-department/?user_id=${userDetails.id}&company_id=${topbarCompanyId}`,
  );
  const [departmentName, setDepartmentName] = useState("All");
  const [departmentId, setDepartmentId] = useState(defaultAllSelection);
  const [userName, setUserName] = useState("All");
  const [userId, setUserId] = useState(defaultAllSelection);
  const [recallApi, setRecallApi] = useState(true);
  const [conutDetails, setCountDetails] = useState([]);
  const [getDepartmentData, setGetDepartmentData] = useState([]);
  const [countRepDetails, setCountRepDetails] = useState([]);
  const { result: membersData, setLoad: reCallMemberApi } = useFetch(
    `${domain}get-department-based-user/?department_id=${departmentId}&user_id=${userDetails.id}&company_id=${topbarCompanyId}`,
  );
  const showToday = false;

  const teamZoneReports = userScreenAccess?.module_details?.find(
    (mod) => mod.module_name === "Reports",
  );

  const subModuleId = teamZoneReports?.submodules?.find(
    (sub) => sub.sub_module_name === "Late Report",
  )?.sub_module_id;

  let check_access = checkViewerPermission(
    userScreenAccess?.module_details,
    "Reports",
    "Late Report",
  );

  useEffect(() => {
    const getFilter = () => {
      const allDepartments = {
        id: defaultAllSelection,
        label: "All",
        department_name: "All",
      };
      const updatedDepartments = (departmentData || []).map((obj) => ({
        ...obj,
        label: obj.department_name,
      }));
      setGetDepartmentData([allDepartments, ...updatedDepartments]);
    };
    getFilter();
  }, [departmentData]);

  useEffect(() => {
    const fetchUserCountDetails = async () => {
      try {
        setIsLoading(true);
        let searchStartDate = startDate.split("/").reverse().join("-");
        let searchEndDate = endDate.split("/").reverse().join("-");
        const response = await fetch(
          `${domain}late-report/?department_id=${departmentId}&start_date=${searchStartDate}&end_date=${searchEndDate}&company_id=${topbarCompanyId}&user_id=${userDetails.id}&selected_user_id=${userId}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `token ${token}`,
            },
          },
        );
        const res = await response.json();
        if (response.ok) {
          setCountRepDetails(res);
        } else if (response.status === 409) {
          setCountRepDetails([]);

          sessionHandling();
        } else {
          setCountRepDetails([]);

          throw new Error('REQUEST_FAILED');
        }
      } catch (error) {
        console.error('[Countreport] operation failed:', error);
        setCountRepDetails([]);

        showToast("error", "Couldn't load the attendance summary. Please try again.");
      } finally {
        setIsLoading(false);
      }
    };
    if (startDate && endDate && departmentId && recallApi && userId) {
      fetchUserCountDetails();
      setRecallApi(false);
    }
  }, [
    domain,
    token,
    startDate,
    endDate,
    departmentId,
    userDetails.id,
    topbarCompanyId,
    recallApi,
    userId,
  ]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const updateUserName = (event, data) => {
    if (data) {
      setUserName(data);
      setUserId(data.user_id);
      reCallMemberApi(true);
      setRecallApi(true);
    }
  };

  const updateDepartmentName = (event, data) => {
    if (data) {
      setDepartmentName(data.department_name);
      setDepartmentId(data.id);
      reCallMemberApi(true);
      setRecallApi(true);
      setUserName("All");
      setUserId(defaultAllSelection);
    }
  };

  const handleCallback = (start, end, rangeLabel) => {
    setStartDate(moment(new Date(start)).format("DD/MM/YYYY"));
    setEndDate(moment(new Date(end)).format("DD/MM/YYYY"));
    setLabelName(rangeLabel);
    reCallMemberApi(true);
    setRecallApi(true);
  };
  useEffect(() => {
    if (topbarCompanyId) {
      setRecallApi(true);
    }
  }, [topbarCompanyId]);

  const handleFilteredDataChange = useCallback(
    (filteredData) => {
      setCountDetails(filteredData);
      if (page * rowsPerPage >= filteredData.length) setPage(0);
    },
    [page, rowsPerPage],
  );

  const getReportMetadata = useCallback(() => {
    const formattedStartDate = moment(
      startDate,
      ["DD/MM/YYYY", "YYYY-MM-DD"],
      true,
    ).format("DD/MM/YYYY");
    const formattedEndDate = moment(
      endDate,
      ["DD/MM/YYYY", "YYYY-MM-DD"],
      true,
    ).format("DD/MM/YYYY");

    return {
      "Company Name": topbarCompanyName || "N/A",
      Department: departmentName || "All",
      "User Name": userName || "All",
      "Date Range": `${formattedStartDate} to ${formattedEndDate}`,
      "Report Generated On": moment().format("DD/MM/YYYY HH:mm:ss"),
    };
  }, [departmentName, endDate, startDate, topbarCompanyName, userName]);

  return isLoading ? (
    <Loader />
  ) : (
    <ThemeProvider theme={withDesignFont(theme)}>
      <FilterProvider
        domain={domain}
        userDetails={userDetails}
        subModuleId={subModuleId}
      >
        <Box sx={BoxStyle}>
          <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
            <IconButton
              onClick={() => setShowReport(false)}
              sx={BackArrowStyle}
            >
              <ArrowBackIos sx={{ fontSize: 18, ml: 0.5 }} />
            </IconButton>

            <Box>
              <Typography
                variant="h5"
                sx={{ fontWeight: 600, lineHeight: 1.2, mb: 0.5 }}
              >
                Late Report
              </Typography>

              <Typography variant="body2" color={designColors.slate600}>
                View late arrival details of your team members
              </Typography>
            </Box>
          </Stack>
          <FilterSection
            filterLabel="Filters"
            filters={[
              {
                width: 400,
                component: (
                  <ApprovalDateRangeFilter
                    thisMonthToDate
                    startDate={startDate}
                    endDate={endDate}
                    dateRangeLabel={labelName}
                    onChange={handleCallback}
                    showToday={showToday}
                    includeCurrentDate={showToday}
                    allowFutureDate={false}
                    sx={filterBarPickerSx}
                  />
                ),
              },
              {
                width: 300,
                props: {
                  dataList: getDepartmentData,
                  selectedValue: departmentName,
                  updateDataFunction: updateDepartmentName,
                  Icons: PersonOutlineIcon,
                  staticLabel: "Department",
                },
              },
              {
                width: 300,
                props: {
                  dataList: membersData.map((obj) => ({
                    ...obj,
                    label: obj.user_name,
                  })),
                  selectedValue: userName,
                  updateDataFunction: updateUserName,
                  Icons: PersonOutlineIcon,
                  staticLabel: "User Name",
                },
              },
            ]}
          />

          <Paper sx={{ width: "100%", height: "76vh", mt: 2 }}>
            <CustomFilter
              title="Late"
              filterHeaders={lateReportHeader}
              data={countRepDetails}
              filteredData={conutDetails}
              onFilteredDataChange={handleFilteredDataChange}
              screenAccess={check_access}
              showtitle_count={true}
              hideCount={true}
              downloadFormats={["excel", "pdf", "csv"]}
              includeMetadata={true}
              metadata={getReportMetadata()}
            />

            <Mui.Grid sx={{ mx: { xs: 0, sm: 2 } }}>
              <Mui.TableContainer sx={{ width: "100%", maxHeight: 550, overflowX: "auto" }}>
                <ApproveTable className="border" sx={{ minWidth: 960 }}>
                  <Mui.TableHead
                    sx={{
                      backgroundColor: themes.primary,
                      position: "sticky",
                      top: -1,
                      zIndex: 10,
                    }}
                  >
                    <Mui.TableRow sx={tableRowSx}>
                      {lateReportHeader.map((header) => (
                        <Mui.TableCell
                          sx={{
                            color: themes.blackColor,
                            fontWeight: "bold",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            maxWidth: 100,
                            width: "10%",
                            textOverflow: "ellipsis",
                          }}
                        >
                          <Mui.Tooltip
                            title={header.name}
                            arrow
                            slotProps={tooltipStyleProps}
                          >
                            {header.name}
                          </Mui.Tooltip>
                        </Mui.TableCell>
                      ))}
                    </Mui.TableRow>
                  </Mui.TableHead>
                  <Mui.TableBody>
                    {conutDetails?.length === 0 && !isLoading ? (
                      <TableEmptyState dataLength={countRepDetails} />
                    ) : (
                      conutDetails
                        ?.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage,
                        )
                        ?.map((item, index) => (
                          <Mui.TableRow key={item?.id} sx={tableRowSx}>
                            {lateReportHeader.map((header) => (
                              <Mui.TableCell>
                                {header.name === "Employee Name" ? (
                                  <Mui.Stack direction="Row">
                                    <Mui.Avatar
                                      sx={{ width: 23, height: 23 }}
                                      alt={item?.username
                                        ?.charAt(0)
                                        .toUpperCase()}
                                      src={item?.image_url ?? optionalAvathar}
                                    />
                                    &nbsp;
                                    {item?.username &&
                                    item.username.length > 10 ? (
                                      <Mui.Tooltip
                                        title={item.username}
                                        arrow
                                        slotProps={tooltipStyleProps}
                                      >
                                        <div
                                          style={{
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                            maxWidth: 100,
                                          }}
                                        >
                                          {item.username}
                                        </div>
                                      </Mui.Tooltip>
                                    ) : (
                                      (item?.username ?? "N/A")
                                    )}
                                  </Mui.Stack>
                                ) : header.name === "Date" ? (
                                  item?.date ? (
                                    item.date.split("-").reverse().join("-")
                                  ) : (
                                    "N/A"
                                  )
                                ) : item[header.key] ? (
                                  item[header.key]
                                ) : (
                                  "N/A"
                                )}
                              </Mui.TableCell>
                            ))}
                          </Mui.TableRow>
                        ))
                    )}
                  </Mui.TableBody>
                </ApproveTable>
              </Mui.TableContainer>
              <Box sx={{ mt: 1 }}>
                {conutDetails?.length > 10 && (
                  <Mui.TablePagination
                    className="custom-pagination"
                    component="div"
                    rowsPerPageOptions={[25, 50, 75, 100]}
                    count={countRepDetails?.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                )}
              </Box>
            </Mui.Grid>
          </Paper>
        </Box>
      </FilterProvider>
    </ThemeProvider>
  );
};
